import React, { useEffect, useState, useCallback, useMemo, Fragment } from 'react';
import {
  IconCheck,
  IconX,
  IconReload,
  IconSearch,
  IconClock,
  IconInbox,
  IconLayoutGrid,
  IconTable,
  IconArrowRight,
  IconLoader2,
  IconCircleCheck,
  IconBan,
  IconChartPie,
  IconListDetails,
  IconUser,
  IconPhoto,
  IconCopy,
  IconBox,
  IconRotateClockwise,
  IconAdjustmentsHorizontal,
  IconCalendar,
} from '@tabler/icons-react';
import Layouts from '../../layouts/Layouts';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Dialog, Transition } from '@headlessui/react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useMasterData } from '../../context/MasterDataContext';
import DetailItem from '../Modal/DetailItem';

export default function VerifikasiTransferTokoV2() {
  const { cabangList = [], kategoriList = [] } = useMasterData() || {};

  // List Data
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  // User Auth & Role
  const userRole = (localStorage.getItem('role') || '').toLowerCase().trim();
  const canVerify = ['admin', 'owner', 'verifikator'].includes(userRole);

  // View Mode: 'table' (default) vs 'cards'
  const [viewMode, setViewMode] = useState('table');

  // Filter States
  const [statusFilter, setStatusFilter] = useState('');
  const [cabangAsalFilter, setCabangAsalFilter] = useState('');
  const [cabangTujuanFilter, setCabangTujuanFilter] = useState('');
  const [kategoriFilter, setKategoriFilter] = useState('');
  const [jenisKategoriFilter, setJenisKategoriFilter] = useState('');
  const [operatorFilter, setOperatorFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Pagination for Pengajuan
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  // Date Filter State
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelectDate = (ranges) => {
    const sel = ranges.selection;
    setStartDate(sel.startDate);
    setEndDate(sel.endDate);
    setCurrentPage(1);
    if (sel.startDate && sel.endDate && sel.startDate.getTime() !== sel.endDate.getTime()) {
      setShowDatePicker(false);
    }
  };

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  // 1-Tap Copy Helper
  const handleCopyNoTransfer = (e, noTransfer) => {
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(noTransfer);
      toast.info(`No. Transfer ${noTransfer} disalin`, { autoClose: 900 });
    }
  };

  // Detail Modal State (Drawer Slide-Over dari Kanan)
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);
  const [selectedTransfer, setSelectedTransfer] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [modalTab, setModalTab] = useState('ringkasan');
  const [searchModalItem, setSearchModalItem] = useState('');

  // Single Item Modal State (DetailItem)
  const [openDetailItemModal, setOpenDetailItemModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null);

  function checkBerat(number) {
    const beratConfirm = parseFloat(number || 0);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
          .toFixed(2)
          .replace(/\.?0+$/, '')
          .replace('.', ',');
  }

  const showDetailItemSingle = (item) => {
    setDetailItem(item);
    setOpenDetailItemModal(true);
  };

  // Confirmation Modal State (Approve / Reject / Batal)
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    id: null,
    action: null, // 'disetujui' | 'ditolak' | 'batal'
    transfer: null,
    wasDetailOpen: false,
  });
  const [catatanVerifikasi, setCatatanVerifikasi] = useState('');
  const [submittingAction, setSubmittingAction] = useState(false);

  // Can Cancel Helper (Allows operator to cancel their shop's pending transfer)
  const canCancelTransfer = useCallback(
    (transfer) => {
      if (!transfer || transfer.status !== 'menunggu_verifikasi') return false;
      if (canVerify) return true;
      const currentUserId = localStorage.getItem('user_id');
      const currentUserName = (localStorage.getItem('name') || '').toLowerCase().trim();
      const currentUserToko = (localStorage.getItem('toko') || '').toLowerCase().trim();
      const userCabangId = localStorage.getItem('cabang_id');

      if (currentUserId && String(transfer.user_pemohon_id) === String(currentUserId)) return true;
      if (currentUserName && (transfer.user_pemohon?.name || '').toLowerCase().trim() === currentUserName) return true;
      if (userCabangId && String(transfer.cabang_asal_id) === String(userCabangId)) return true;
      if (currentUserToko && (transfer.cabang_asal?.nama_cabang || '').toLowerCase().trim().includes(currentUserToko)) return true;
      if (!canVerify && ['operator', 'operator_toko', 'kepala_toko'].includes(userRole)) return true;

      return false;
    },
    [canVerify, userRole]
  );

  const resolveItemImageUrl = (item) => {
    if (!item) return '';
    let gData = item.gambar1 || item.gambar;
    if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
      try {
        gData = JSON.parse(gData);
      } catch (e) {}
    }
    if (Array.isArray(gData) && gData.length > 0) {
      const path = gData[0]?.asli || gData[0]?.thumbnail || (typeof gData[0] === 'string' ? gData[0] : '');
      return path ? (path.startsWith('http') ? path : `${imageBaseUrl}${path}`) : '';
    }
    if (typeof gData === 'string' && gData.length > 0) {
      return gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
    }
    return '';
  };

  // Fetch List Data from API
  const fetchData = useCallback(async (customParams = null) => {
    setLoading(true);
    try {
      const params = {
        per_page: 150, // Load comprehensive batch for smooth tab view & filtering
      };

      if (customParams) {
        if (customParams.start_date !== undefined) params.start_date = customParams.start_date;
        if (customParams.end_date !== undefined) params.end_date = customParams.end_date;
      } else if (startDate && endDate) {
        params.start_date = moment(startDate).format('DD-MM-YYYY');
        params.end_date = moment(endDate).format('DD-MM-YYYY');
      }

      const res = await http.get('transfer-antar-toko', {
        params,
        headers: { Authorization: getAuthorizationHeader() },
      });

      if (res.data?.status) {
        const fetchedList = res.data.data?.data || res.data.data || [];
        setData(fetchedList);
      }
    } catch (err) {
      console.error('Gagal mengambil data transfer antar toko:', err);
      toast.error('Gagal memuat data transfer antar toko');
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Reload handler: resets all filters to default and reloads default dataset
  const handleReloadDefault = useCallback(() => {
    setStatusFilter('');
    setStartDate(null);
    setEndDate(null);
    setShowDatePicker(false);
    setCabangAsalFilter('');
    setCabangTujuanFilter('');
    setKategoriFilter('');
    setJenisKategoriFilter('');
    setOperatorFilter('');
    setSearchQuery('');
    setCurrentPage(1);
    fetchData({ start_date: undefined, end_date: undefined });
  }, [fetchData]);

  // Open Detail Modal
  const handleOpenDetail = async (transferId, preloadedItem = null, defaultTab = 'ringkasan') => {
    setLoadingDetail(true);
    setIsOpenDetailModal(true);
    setModalTab(defaultTab);
    setSearchModalItem('');
    if (preloadedItem) {
      setSelectedTransfer(preloadedItem);
    }
    try {
      const res = await http.get(`transfer-antar-toko/${transferId}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (res.data?.status || res.data?.data) {
        setSelectedTransfer(res.data.data || res.data);
      }
    } catch (err) {
      console.error('Gagal mengambil detail transfer:', err);
      toast.error('Gagal memuat detail transfer');
    } finally {
      setLoadingDetail(false);
    }
  };

  // Open Confirmation Modal
  const openConfirm = (transfer, action) => {
    const wasDetail = isOpenDetailModal;
    if (wasDetail) {
      setIsOpenDetailModal(false);
    }
    setConfirmModal({
      isOpen: true,
      id: transfer.id,
      action: action,
      transfer: transfer,
      wasDetailOpen: wasDetail,
    });
    setCatatanVerifikasi('');
  };

  const closeConfirm = () => {
    if (confirmModal.wasDetailOpen) {
      setIsOpenDetailModal(true);
    }
    setConfirmModal({
      isOpen: false,
      id: null,
      action: null,
      transfer: null,
      wasDetailOpen: false,
    });
    setCatatanVerifikasi('');
  };

  // Submit Approval / Rejection / Cancellation
  const handleConfirmSubmit = async () => {
    const { id, action } = confirmModal;
    if (!id || !action) return;

    if (action === 'ditolak' && !catatanVerifikasi.trim()) {
      toast.error('Wajib mengisi catatan/alasan penolakan!');
      return;
    }

    setSubmittingAction(true);
    try {
      if (action === 'batal') {
        const res = await http.post(
          `transfer-antar-toko/${id}/batalkan`,
          {
            alasan_batal: catatanVerifikasi.trim() || null,
            alasan: catatanVerifikasi.trim() || null,
            catatan: catatanVerifikasi.trim() || null,
          },
          { headers: { Authorization: getAuthorizationHeader() } }
        );
        if (res.data?.status) {
          toast.success(res.data.message || 'Pengajuan transfer berhasil dibatalkan');
        }
      } else {
        const res = await http.post(
          `transfer-antar-toko/${id}/verifikasi`,
          {
            action: action,
            catatan_verifikasi: catatanVerifikasi.trim() || null,
          },
          { headers: { Authorization: getAuthorizationHeader() } }
        );
        if (res.data?.status) {
          toast.success(
            res.data.message ||
              (action === 'disetujui' ? 'Transfer disetujui!' : 'Transfer ditolak!')
          );
        }
      }

      setConfirmModal({ isOpen: false, id: null, action: null, transfer: null, wasDetailOpen: false });
      setIsOpenDetailModal(false);
      setCatatanVerifikasi('');
      fetchData();
      window.dispatchEvent(new Event('refresh-pending-verification'));
    } catch (err) {
      console.error('Gagal memproses verifikasi:', err);
      toast.error(err.response?.data?.message || 'Gagal memproses verifikasi');
    } finally {
      setSubmittingAction(false);
    }
  };

  // Detail Summary Calculator
  const detailSummary = useMemo(() => {
    if (!selectedTransfer || !selectedTransfer.items) return {};
    return selectedTransfer.items.reduce((acc, item) => {
      const catName =
        item.jenis_kategori?.kategori?.nama_kategori ||
        item.kategori?.nama_kategori ||
        item.jenis_kategori?.nama_jenis ||
        item.kategori ||
        'Tanpa Kategori';
      const karat = item.karat || '-';
      const berat = parseFloat(item.berat || 0);

      if (!acc[catName]) acc[catName] = { name: catName, pcs: 0, berat: 0, byKarat: {} };
      acc[catName].pcs += 1;
      acc[catName].berat += berat;

      if (!acc[catName].byKarat[karat]) acc[catName].byKarat[karat] = { pcs: 0, berat: 0 };
      acc[catName].byKarat[karat].pcs += 1;
      acc[catName].byKarat[karat].berat += berat;

      return acc;
    }, {});
  }, [selectedTransfer]);

  // Filtered items inside Detail Modal
  const filteredModalItems = useMemo(() => {
    if (!selectedTransfer || !selectedTransfer.items) return [];
    if (!searchModalItem.trim()) return selectedTransfer.items;
    const q = searchModalItem.toLowerCase();
    return selectedTransfer.items.filter((it) => {
      const kode = it.kode_item ? it.kode_item.toLowerCase() : '';
      const jenis = it.jenis_kategori?.nama_jenis ? it.jenis_kategori.nama_jenis.toLowerCase() : '';
      const kat = it.jenis_kategori?.kategori?.nama_kategori
        ? it.jenis_kategori.kategori.nama_kategori.toLowerCase()
        : it.kategori?.nama_kategori
        ? it.kategori.nama_kategori.toLowerCase()
        : '';
      const baki = it.nomor_rak ? it.nomor_rak.toString().toLowerCase() : '';
      return kode.includes(q) || jenis.includes(q) || kat.includes(q) || baki.includes(q);
    });
  }, [selectedTransfer, searchModalItem]);

  // Options for Cabang (Hanya Toko / is_toko = true & Bukan Brankas)
  const cabangOptions = useMemo(() => {
    const list = new Set();
    cabangList.forEach((c) => {
      const isToko = c.is_toko === true || c.is_toko === 1 || c.is_toko === '1';
      const name = c.nama_cabang || c.nama || (typeof c === 'string' ? c : null);
      if (name && isToko && !name.toLowerCase().includes('brankas')) {
        list.add(name);
      }
    });

    // Fallback jika cabangList belum siap dari context
    if (list.size === 0) {
      data.forEach((d) => {
        const asal = d.cabang_asal?.nama_cabang;
        const tujuan = d.cabang_tujuan?.nama_cabang;
        if (asal && !asal.toLowerCase().includes('brankas')) list.add(asal);
        if (tujuan && !tujuan.toLowerCase().includes('brankas')) list.add(tujuan);
      });
    }
    return Array.from(list);
  }, [cabangList, data]);

  const kategoriOptions = useMemo(() => {
    const list = new Set();
    kategoriList.forEach((k) => {
      const name = k.nama_kategori || k.nama || (typeof k === 'string' ? k : null);
      if (name) list.add(name);
    });
    data.forEach((d) => {
      d.items?.forEach((child) => {
        const itemObj = child.item || child;
        const name =
          itemObj?.jenis_kategori?.kategori?.nama_kategori ||
          itemObj?.kategori?.nama_kategori ||
          (typeof itemObj?.kategori === 'string' ? itemObj.kategori : null);
        if (name) list.add(name);
      });
    });
    return Array.from(list);
  }, [kategoriList, data]);

  const jenisKategoriOptions = useMemo(() => {
    if (!kategoriFilter) return [];

    const list = new Set();
    const targetKategori = kategoriFilter.trim().toLowerCase();
    
    // Dari master data kategoriList:
    kategoriList.forEach((k) => {
      const katName = k.nama_kategori || k.nama || (typeof k === 'string' ? k : null);
      if (katName && katName.trim().toLowerCase() === targetKategori) {
        if (Array.isArray(k.jenis_kategori)) {
          k.jenis_kategori.forEach((jk) => {
            const jName = jk.nama_jenis || jk.nama;
            if (jName) list.add(jName);
          });
        }
      }
    });

    // Dari data actual transfer:
    data.forEach((d) => {
      d.items?.forEach((child) => {
        const itemObj = child.item || child;
        const katName =
          itemObj?.jenis_kategori?.kategori?.nama_kategori ||
          itemObj?.kategori?.nama_kategori ||
          (typeof itemObj?.kategori === 'string' ? itemObj.kategori : null);
        const jName = itemObj?.jenis_kategori?.nama_jenis || itemObj?.nama_jenis;

        if (jName && katName && katName.trim().toLowerCase() === targetKategori) {
          list.add(jName);
        }
      });
    });

    return Array.from(list);
  }, [kategoriList, data, kategoriFilter]);

  const operatorOptions = useMemo(() => {
    const list = new Set();
    data.forEach((d) => {
      const name = d.user_pemohon?.name || d.userPemohon?.name;
      if (name) list.add(name);
    });
    return Array.from(list);
  }, [data]);

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDatePicker(false);
    setStatusFilter('');
    setCabangAsalFilter('');
    setCabangTujuanFilter('');
    setKategoriFilter('');
    setJenisKategoriFilter('');
    setOperatorFilter('');
    setSearchQuery('');
    setCurrentPage(1);
  };

  // Filtered Pengajuan List
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      if (statusFilter) {
        if (statusFilter === 'menunggu_verifikasi' && item.status !== 'menunggu_verifikasi') return false;
        if (statusFilter === 'disetujui' && item.status !== 'disetujui') return false;
        if (statusFilter === 'ditolak' && item.status !== 'ditolak') return false;
        if (statusFilter === 'dibatalkan' && item.status !== 'dibatalkan') return false;
      }
      if (cabangAsalFilter && item.cabang_asal?.nama_cabang !== cabangAsalFilter) {
        return false;
      }
      if (cabangTujuanFilter && item.cabang_tujuan?.nama_cabang !== cabangTujuanFilter) {
        return false;
      }
      if (kategoriFilter) {
        const matchKategori = item.items?.some((it) => {
          const itemObj = it.item || it;
          const cat =
            itemObj?.jenis_kategori?.kategori?.nama_kategori ||
            itemObj?.kategori?.nama_kategori ||
            (typeof itemObj?.kategori === 'string' ? itemObj.kategori : '');
          return cat && cat.toLowerCase().includes(kategoriFilter.toLowerCase());
        });
        if (!matchKategori) return false;
      }
      if (jenisKategoriFilter) {
        const matchJenis = item.items?.some((it) => {
          const itemObj = it.item || it;
          const jName = itemObj?.jenis_kategori?.nama_jenis || itemObj?.nama_jenis;
          return jName && jName.toLowerCase().includes(jenisKategoriFilter.toLowerCase());
        });
        if (!matchJenis) return false;
      }
      if (operatorFilter) {
        const name = item.user_pemohon?.name || item.userPemohon?.name;
        if (name !== operatorFilter) return false;
      }
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        const noTrx = item.no_transfer ? item.no_transfer.toLowerCase() : '';
        const asal = item.cabang_asal?.nama_cabang ? item.cabang_asal.nama_cabang.toLowerCase() : '';
        const tujuan = item.cabang_tujuan?.nama_cabang ? item.cabang_tujuan.nama_cabang.toLowerCase() : '';
        const pemohon = (item.user_pemohon?.name || item.userPemohon?.name || '').toLowerCase();
        if (!noTrx.includes(q) && !asal.includes(q) && !tujuan.includes(q) && !pemohon.includes(q)) {
          return false;
        }
      }
      if (startDate && endDate) {
        const itemDate = moment(item.created_at);
        const start = moment(startDate).startOf('day');
        const end = moment(endDate).endOf('day');
        if (!itemDate.isBetween(start, end, null, '[]')) {
          return false;
        }
      }
      return true;
    });
  }, [data, statusFilter, cabangAsalFilter, cabangTujuanFilter, kategoriFilter, jenisKategoriFilter, operatorFilter, searchQuery, startDate, endDate]);

  // Paginated Pengajuan
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const paginatedData = useMemo(() => {
    return filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  // Active Filter Chips
  const activeFilters = useMemo(() => {
    const list = [];
    if (statusFilter) {
      const statusMap = {
        menunggu_verifikasi: 'Menunggu Verifikasi',
        disetujui: 'Disetujui',
        ditolak: 'Ditolak',
        dibatalkan: 'Dibatalkan',
      };
      list.push({
        id: 'status',
        label: `Status: ${statusMap[statusFilter] || statusFilter}`,
        icon: '📋',
        onClear: () => {
          setStatusFilter('');
          setCurrentPage(1);
        },
      });
    }
    if (startDate && endDate) {
      list.push({
        id: 'tanggal',
        label: awal === akhir ? `Tanggal: ${awal}` : `Tanggal: ${awal} - ${akhir}`,
        icon: '📅',
        onClear: () => {
          setStartDate(null);
          setEndDate(null);
          setCurrentPage(1);
        },
      });
    }
    if (cabangAsalFilter) {
      list.push({
        id: 'cabang_asal',
        label: `Asal: ${cabangAsalFilter}`,
        icon: '🏪',
        onClear: () => {
          setCabangAsalFilter('');
          setCurrentPage(1);
        },
      });
    }
    if (cabangTujuanFilter) {
      list.push({
        id: 'cabang_tujuan',
        label: `Tujuan: ${cabangTujuanFilter}`,
        icon: '🎯',
        onClear: () => {
          setCabangTujuanFilter('');
          setCurrentPage(1);
        },
      });
    }
    if (kategoriFilter) {
      list.push({
        id: 'kategori',
        label: `Kategori: ${kategoriFilter}`,
        icon: '🏷️',
        onClear: () => {
          setKategoriFilter('');
          setJenisKategoriFilter('');
          setCurrentPage(1);
        },
      });
    }
    if (jenisKategoriFilter) {
      list.push({
        id: 'jenis_kategori',
        label: `Jenis: ${jenisKategoriFilter}`,
        icon: '💍',
        onClear: () => {
          setJenisKategoriFilter('');
          setCurrentPage(1);
        },
      });
    }
    if (operatorFilter) {
      list.push({
        id: 'operator',
        label: `Pemohon: ${operatorFilter}`,
        icon: '👤',
        onClear: () => {
          setOperatorFilter('');
          setCurrentPage(1);
        },
      });
    }
    return list;
  }, [statusFilter, startDate, endDate, awal, akhir, cabangAsalFilter, cabangTujuanFilter, kategoriFilter, jenisKategoriFilter, operatorFilter]);

  const activeFilterCount = activeFilters.length;
  const hasActiveFilters = activeFilterCount > 0 || Boolean(searchQuery);

  const renderStatusBadge = (status, isCompact = false) => {
    switch (status) {
      case 'menunggu_verifikasi':
        return (
          <span
            className={`inline-flex items-center gap-1 font-bold rounded-lg border bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border-amber-300 dark:border-amber-700 ${
              isCompact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            }`}
          >
            <IconClock size={isCompact ? 12 : 14} /> Menunggu Verifikasi
          </span>
        );
      case 'disetujui':
        return (
          <span
            className={`inline-flex items-center gap-1 font-bold rounded-lg border bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-700 ${
              isCompact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            }`}
          >
            <IconCheck size={isCompact ? 12 : 14} /> Disetujui
          </span>
        );
      case 'ditolak':
        return (
          <span
            className={`inline-flex items-center gap-1 font-bold rounded-lg border bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 border-rose-300 dark:border-rose-700 ${
              isCompact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            }`}
          >
            <IconX size={isCompact ? 12 : 14} /> Ditolak
          </span>
        );
      case 'dibatalkan':
        return (
          <span
            className={`inline-flex items-center gap-1 font-bold rounded-lg border bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-300 dark:border-slate-700 ${
              isCompact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
            }`}
          >
            <IconBan size={isCompact ? 12 : 14} /> Dibatalkan
          </span>
        );
      default:
        return <span className="text-xs">{status}</span>;
    }
  };

  return (
    <Layouts 
    title="Transfer Antar Toko"
    >
      {/* Single Item Modal Detail */}
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={() => setOpenDetailItemModal(false)}
        openDetail={openDetailItemModal}
      />

      <div className="p-3 sm:p-4 lg:p-6 w-full space-y-4 min-h-[85vh]">
        {/* Top Header Card */}
        <div className="bg-white dark:bg-slate-900 p-4 sm:p-5 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm">
          {/* Search & Actions Toolbar: Unified Row */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 pt-3">
            {/* Search Input */}
            <div className="relative flex-1">
              <IconSearch size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                placeholder="Cari no. transfer, toko asal, toko tujuan, pemohon..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full pl-10 pr-9 py-2 sm:py-2.5 text-xs sm:text-sm bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-slate-100 placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all"
              />
              {searchQuery && (
                <button
                  type="button"
                  onClick={() => setSearchQuery('')}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-0.5 cursor-pointer"
                >
                  <IconX size={15} />
                </button>
              )}
            </div>

            {/* Actions Toolbar: Filter, View Switcher, and Reload */}
            <div className="flex items-center gap-2 self-end sm:self-center shrink-0">
              {/* Filter Button */}
              <button
                type="button"
                onClick={() => setIsFilterOpen(true)}
                className={`flex items-center gap-1.5 px-3 py-2 sm:py-2.5 rounded-xl text-xs sm:text-sm font-semibold border transition-all shrink-0 cursor-pointer shadow-xs ${
                  isFilterOpen || activeFilterCount > 0
                    ? 'bg-amber-500 border-amber-600 text-white shadow-amber-500/20'
                    : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:border-amber-400'
                }`}
                title="Buka Filter Transfer Antar Toko"
              >
                <IconAdjustmentsHorizontal size={17} />
                <span>Filter</span>
                {activeFilterCount > 0 && (
                  <span
                    className={`px-1.5 py-0.2 text-[10px] font-bold rounded-full leading-tight ${
                      isFilterOpen || activeFilterCount > 0 ? 'bg-white text-amber-700' : 'bg-amber-500 text-white'
                    }`}
                  >
                    {activeFilterCount}
                  </span>
                )}
              </button>

              {/* View Mode Switcher (Tabel / Kartu) */}
              <div className="flex items-center bg-slate-100 dark:bg-slate-800 p-1 rounded-xl border border-slate-200/70 dark:border-slate-700">
                <button
                  type="button"
                  onClick={() => setViewMode('table')}
                  className={`p-1.5 sm:px-2.5 sm:py-1 rounded-lg text-xs font-semibold flex items-center gap-1 transition-all cursor-pointer ${
                    viewMode === 'table'
                      ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                      : 'text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'
                  }`}
                  title="Tampilan Tabel (Default)"
                >
                  <IconTable size={16} />
                  <span className="hidden sm:inline">Tabel</span>
                </button>
                <button
                  type="button"
                  onClick={() => setViewMode('cards')}
                  className={`p-1.5 sm:px-2.5 sm:py-1 rounded-lg text-xs font-semibold flex items-center gap-1 transition-all cursor-pointer ${
                    viewMode === 'cards'
                      ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
                      : 'text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'
                  }`}
                  title="Tampilan Kartu"
                >
                  <IconLayoutGrid size={16} />
                  <span className="hidden sm:inline">Kartu</span>
                </button>
              </div>

              {/* Reload / Refresh Default Button */}
              <button
                type="button"
                onClick={handleReloadDefault}
                disabled={loading}
                className="p-2 sm:px-3 sm:py-2 text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700/60 border border-slate-200/80 dark:border-slate-700 rounded-xl transition-all cursor-pointer shadow-xs flex items-center gap-1.5 text-xs font-semibold"
                title="Reset Semua Filter & Refresh Data Default"
              >
                <IconReload size={17} className={loading ? 'animate-spin text-amber-500' : ''} />
                <span className="hidden md:inline">Refresh</span>
              </button>
            </div>
          </div>

          {/* Horizontal Status Chips (Touch friendly pill bar) */}
          <div className="flex items-center gap-1.5 overflow-x-auto pt-2.5 pb-1 scrollbar-none">
            {[
              { label: 'Semua Status', value: '' },
              { label: 'Menunggu Verifikasi', value: 'menunggu_verifikasi', badgeColor: 'bg-amber-500' },
              { label: 'Disetujui', value: 'disetujui', badgeColor: 'bg-emerald-500' },
              { label: 'Ditolak', value: 'ditolak', badgeColor: 'bg-rose-500' },
              { label: 'Dibatalkan', value: 'dibatalkan', badgeColor: 'bg-slate-400' },
            ].map((chip) => {
              const isActive = statusFilter === chip.value;
              return (
                <button
                  key={chip.value}
                  type="button"
                  onClick={() => {
                    setStatusFilter(chip.value);
                    setCurrentPage(1);
                  }}
                  className={`px-3 py-1.5 rounded-xl text-xs font-semibold whitespace-nowrap transition-all flex items-center gap-1.5 cursor-pointer ${
                    isActive
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
                  }`}
                >
                  {chip.badgeColor && (
                    <span
                      className={`w-2 h-2 rounded-full ${chip.badgeColor} ${isActive ? 'ring-2 ring-white/50' : ''}`}
                    />
                  )}
                  <span>{chip.label}</span>
                </button>
              );
            })}
          </div>

          {/* Active Filter Chips Bar */}
          {activeFilters.length > 0 && (
            <div className="flex items-center gap-1.5 flex-wrap pt-2.5 border-t border-slate-100 dark:border-slate-800 mt-2">
              <span className="text-[11px] text-slate-400 font-medium">Filter aktif:</span>
              {activeFilters.map((flt) => (
                <div
                  key={flt.id}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-900/60 text-amber-800 dark:text-amber-300 text-xs font-medium"
                >
                  <span>{flt.icon}</span>
                  <span>{flt.label}</span>
                  <button
                    type="button"
                    onClick={flt.onClear}
                    className="hover:text-rose-600 p-0.5 rounded cursor-pointer ml-0.5"
                    title="Hapus filter ini"
                  >
                    <IconX size={13} />
                  </button>
                </div>
              ))}

              <button
                type="button"
                onClick={handleResetFilter}
                className="text-[11px] font-bold text-rose-600 dark:text-rose-400 hover:underline px-2 py-0.5 rounded shrink-0 cursor-pointer whitespace-nowrap"
              >
                Reset Semua
              </button>
            </div>
          )}

          {/* ═══ Filter Slide-over Drawer (Muncul dari Kanan Layar) ═══ */}
          <Transition appear show={isFilterOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[99999]" onClose={() => setIsFilterOpen(false)}>
              {/* Backdrop Overlay Tipis & Tanpa Blur */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-slate-900/15 dark:bg-black/30 pointer-events-auto" />
              </Transition.Child>

              {/* Drawer Container */}
              <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-300 sm:duration-400"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-300 sm:duration-400"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-[340px] sm:max-w-[420px] md:max-w-[460px] transform bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 text-left align-middle transition-all flex flex-col h-screen max-h-screen">
                      {/* Drawer Header */}
                      <div className="px-5 py-4 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between shrink-0 sticky top-0 z-20">
                        <div className="flex items-center gap-2.5">
                          <div className="p-2 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400">
                            <IconAdjustmentsHorizontal size={20} />
                          </div>
                          <div>
                            <Dialog.Title as="h2" className="text-base font-bold text-slate-800 dark:text-slate-100">
                              Filter Transfer Antar Toko
                            </Dialog.Title>
                            <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                              {activeFilterCount > 0 ? `${activeFilterCount} kriteria filter aktif` : 'Sesuaikan parameter pencarian'}
                            </p>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => setIsFilterOpen(false)}
                          className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                        >
                          <IconX size={18} />
                        </button>
                      </div>

                      {/* Drawer Body (Scrollable) */}
                      <div className="p-5 flex-1 overflow-y-auto space-y-4">
                        {/* 1. Filter Tanggal Permohonan (Collapsible / Trigger Klik) */}
                        <div>
                          <div className="flex items-center justify-between mb-1.5">
                            {startDate && (
                              <button
                                type="button"
                                onClick={() => {
                                  setStartDate(null);
                                  setEndDate(null);
                                  setShowDatePicker(false);
                                  setCurrentPage(1);
                                }}
                                className="text-[11px] font-bold text-rose-500 hover:underline cursor-pointer"
                              >
                                Reset Tanggal
                              </button>
                            )}
                          </div>

                          {/* Trigger Button untuk membuka kalender */}
                          <button
                            type="button"
                            onClick={() => setShowDatePicker((prev) => !prev)}
                            className={`w-full h-11 border rounded-xl px-3.5 flex items-center justify-between transition-all cursor-pointer text-xs sm:text-sm font-medium ${
                              showDatePicker
                                ? 'border-amber-500 ring-2 ring-amber-500/20 bg-amber-50/40 dark:bg-amber-950/20 text-amber-700 dark:text-amber-300'
                                : startDate && endDate
                                ? 'border-amber-400 bg-amber-50/20 dark:bg-amber-950/10 text-slate-800 dark:text-slate-100'
                                : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:border-amber-400'
                            }`}
                          >
                            <div className="flex items-center gap-2 overflow-hidden">
                              <IconCalendar size={18} className="text-amber-500 shrink-0" />
                              <span className="truncate">
                                {startDate && endDate
                                  ? `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`
                                  : 'Pilih Rentang Tanggal'}
                              </span>
                            </div>
                            <span className="text-[11px] text-slate-400 font-semibold shrink-0 ml-2">
                              {showDatePicker ? 'Tutup ▲' : 'Buka ▼'}
                            </span>
                          </button>

                          {/* Kalender DateRange: hanya muncul setelah tombol trigger diklik */}
                          {showDatePicker && (
                            <div className="mt-2.5 border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden p-2 flex flex-col items-center bg-white dark:bg-slate-800 shadow-sm animate-in fade-in duration-150">
                              <DateRange
                                ranges={[selectionRange]}
                                onChange={handleSelectDate}
                                rangeColors={['#f59e0b']}
                                months={1}
                                direction="horizontal"
                                showDateDisplay={false}
                                moveRangeOnFirstSelection={false}
                              />
                              <div className="w-full flex items-center justify-between pt-2 border-t border-slate-100 dark:border-slate-700 mt-1 px-1">
                                <span className="text-[11px] text-slate-500 dark:text-slate-400 font-medium">
                                  {startDate && endDate ? `${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}` : 'Pilih rentang tanggal'}
                                </span>
                                <button
                                  type="button"
                                  onClick={() => setShowDatePicker(false)}
                                  className="px-2.5 py-1 text-xs text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition cursor-pointer font-semibold"
                                >
                                  Tutup
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* 2. Filter Status Transfer */}
                        <div>
                          <select
                            value={statusFilter}
                            onChange={(e) => {
                              setStatusFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                          >
                            <option value="">Semua Status</option>
                            <option value="menunggu_verifikasi">Menunggu Verifikasi</option>
                            <option value="disetujui">Disetujui</option>
                            <option value="ditolak">Ditolak</option>
                            <option value="dibatalkan">Dibatalkan</option>
                          </select>
                        </div>

                        {/* 3. Toko Asal */}
                        <div>
                          <select
                            value={cabangAsalFilter}
                            onChange={(e) => {
                              setCabangAsalFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                          >
                            <option value="">Semua Toko Asal</option>
                            {cabangOptions.map((c, i) => (
                              <option key={i} value={c}>
                                {c}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 4. Toko Tujuan */}
                        <div>
                          <select
                            value={cabangTujuanFilter}
                            onChange={(e) => {
                              setCabangTujuanFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                          >
                            <option value="">Semua Toko Tujuan</option>
                            {cabangOptions.map((c, i) => (
                              <option key={i} value={c}>
                                {c}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 5. Kategori Barang */}
                        <div>
                          <select
                            value={kategoriFilter}
                            onChange={(e) => {
                              setKategoriFilter(e.target.value);
                              setJenisKategoriFilter('');
                              setCurrentPage(1);
                            }}
                            className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                          >
                            <option value="">Semua Kategori</option>
                            {kategoriOptions.map((k, i) => (
                              <option key={i} value={k}>
                                {k}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 6. Jenis Kategori Barang */}
                        <div>
                          <select
                            value={jenisKategoriFilter}
                            disabled={!kategoriFilter}
                            onChange={(e) => {
                              setJenisKategoriFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className={`w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 outline-none font-medium shadow-xs transition-colors ${
                              !kategoriFilter
                                ? 'opacity-60 cursor-not-allowed bg-slate-100 dark:bg-slate-800/50 text-slate-400 dark:text-slate-500'
                                : 'cursor-pointer hover:border-amber-400 dark:hover:border-amber-500'
                            }`}
                          >
                            <option value="">
                              {!kategoriFilter ? 'Pilih Kategori Terlebih Dahulu' : 'Semua Jenis Kategori'}
                            </option>
                            {jenisKategoriOptions.map((jk, i) => (
                              <option key={i} value={jk}>
                                {jk}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 7. Operator Pemohon */}
                        <div>
                          <select
                            value={operatorFilter}
                            onChange={(e) => {
                              setOperatorFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="w-full h-11 border border-slate-200 dark:border-slate-700 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-400 dark:hover:border-amber-500 outline-none font-medium shadow-xs"
                          >
                            <option value="">Semua Operator</option>
                            {operatorOptions.map((op, i) => (
                              <option key={i} value={op}>
                                {op}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Drawer Footer (Sticky Bottom) */}
                      <div className="p-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-900/80 flex items-center justify-between gap-3 shrink-0">
                        <span className="text-xs text-slate-500 dark:text-slate-400">
                          Total: <strong className="text-slate-700 dark:text-slate-200">{filteredData.length}</strong> permohonan
                        </span>
                        <div className="flex items-center gap-2">
                          {activeFilterCount > 0 && (
                            <button
                              type="button"
                              onClick={handleResetFilter}
                              className="px-3 py-2 text-xs font-semibold text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-xl transition cursor-pointer flex items-center gap-1"
                            >
                              <IconRotateClockwise size={14} />
                              <span>Reset</span>
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => setIsFilterOpen(false)}
                            className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white font-bold text-xs rounded-xl shadow-sm transition cursor-pointer"
                          >
                            Tutup
                          </button>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>

        {/* ═══ Content Container: Permohonan Transfer ═══ */}
        <div>
            {loading ? (
              <div className="py-24 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm flex flex-col items-center justify-center gap-3">
                <IconLoader2 size={36} className="animate-spin text-amber-500" />
                <p className="text-slate-400 text-xs font-semibold animate-pulse">Memuat data transfer antar toko...</p>
              </div>
            ) : paginatedData.length === 0 ? (
              <div className="py-20 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm flex flex-col items-center justify-center text-center p-6 space-y-3">
                <div className="w-16 h-16 bg-amber-50 dark:bg-slate-800 rounded-full flex items-center justify-center text-amber-500">
                  <IconInbox size={32} />
                </div>
                <div>
                  <h3 className="font-bold text-sm text-slate-800 dark:text-slate-200">
                    Tidak Ada Permohonan Transfer Ditemukan
                  </h3>
                  <p className="text-xs text-slate-500 dark:text-slate-400 max-w-sm mt-1">
                    {hasActiveFilters
                      ? 'Tidak ada riwayat transfer antar toko yang sesuai dengan filter atau kata kunci Anda.'
                      : 'Belum ada data permohonan transfer antar toko yang tersimpan.'}
                  </p>
                </div>
                {hasActiveFilters && (
                  <button
                    type="button"
                    onClick={handleResetFilter}
                    className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold rounded-xl shadow-sm transition-all cursor-pointer"
                  >
                    Reset Semua Filter
                  </button>
                )}
              </div>
            ) : viewMode === 'cards' ? (
              /* CARD FEED VIEW FOR TRANSFER TOKO */
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3 sm:gap-4">
                  {paginatedData.map((trx) => {
                    const totalPcs = trx.total_item || (trx.items ? trx.items.length : 0);
                    const totalBerat = parseFloat(
                      trx.total_berat ||
                        (trx.items ? trx.items.reduce((acc, it) => acc + parseFloat(it.berat || 0), 0) : 0)
                    ).toFixed(3);
                    const isPending = trx.status === 'menunggu_verifikasi';

                    return (
                      <div
                        key={trx.id}
                        className={`bg-white dark:bg-slate-900 rounded-2xl p-4 sm:p-5 border transition-all duration-200 flex flex-col justify-between shadow-sm hover:shadow-md ${
                          isPending
                            ? 'border-amber-300/80 dark:border-amber-700/60 ring-1 ring-amber-400/20'
                            : 'border-slate-200/80 dark:border-slate-800'
                        }`}
                      >
                        {/* Top: No Transfer, Status, Date */}
                        <div>
                          <div className="flex items-start justify-between gap-2 pb-2.5 border-b border-slate-100 dark:border-slate-800">
                            <div>
                              <div className="flex items-center gap-1.5">
                                <span className="font-mono font-extrabold text-sm sm:text-base text-slate-900 dark:text-slate-100 tracking-tight">
                                  {trx.no_transfer}
                                </span>
                                <button
                                  type="button"
                                  onClick={(e) => handleCopyNoTransfer(e, trx.no_transfer)}
                                  className="text-slate-400 hover:text-amber-500 p-0.5 rounded transition-colors cursor-pointer"
                                  title="Salin No. Transfer"
                                >
                                  <IconCopy size={14} />
                                </button>
                              </div>
                              <p className="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5 flex items-center gap-1">
                                <IconClock size={13} />
                                <span>{moment(trx.created_at).format('DD MMM YYYY, HH.mm')}</span>
                              </p>
                            </div>
                            <div>{renderStatusBadge(trx.status, true)}</div>
                          </div>

                          {/* Route Asal ➔ Tujuan */}
                          <div className="my-3 p-2.5 rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-800 flex items-center justify-between text-xs">
                            <div className="flex-1 truncate">
                              <span className="text-[10px] text-slate-400 uppercase block">Dari</span>
                              <span className="font-bold text-slate-800 dark:text-slate-200 truncate block mt-0.5">
                                {trx.cabang_asal?.nama_cabang || 'Toko Asal'}
                              </span>
                            </div>
                            <div className="px-2 text-amber-500 shrink-0">
                              <IconArrowRight size={16} />
                            </div>
                            <div className="flex-1 text-right truncate">
                              <span className="text-[10px] text-slate-400 uppercase block">Tujuan</span>
                              <span className="font-bold text-amber-600 dark:text-amber-400 truncate block mt-0.5">
                                {trx.cabang_tujuan?.nama_cabang || 'Toko Tujuan'}
                              </span>
                            </div>
                          </div>

                          {/* Body: Pemohon, Verifikator, Metrics */}
                          <div className="space-y-2 text-xs">
                            <div className="flex items-center justify-between">
                              <span className="text-slate-500 dark:text-slate-400 flex items-center gap-1">
                                <IconUser size={15} className="text-amber-500" />
                                <span>Pemohon:</span>
                              </span>
                              <span className="font-semibold text-slate-700 dark:text-slate-300 text-right">
                                {trx.user_pemohon?.name || trx.userPemohon?.name || 'Operator'}
                              </span>
                            </div>

                            {trx.user_verifikator?.name && (
                              <div className="flex items-center justify-between">
                                <span className="text-slate-500 dark:text-slate-400 flex items-center gap-1">
                                  <IconCircleCheck size={15} className="text-emerald-500" />
                                  <span>Verifikator:</span>
                                </span>
                                <span className="font-semibold text-emerald-600 dark:text-emerald-400 text-right">
                                  {trx.user_verifikator.name}
                                </span>
                              </div>
                            )}

                            {trx.catatan_pemohon && (
                              <div className="p-2 rounded-lg bg-slate-50 dark:bg-slate-800/40 text-[11px] text-slate-600 dark:text-slate-400 italic truncate">
                                "{trx.catatan_pemohon}"
                              </div>
                            )}

                            {/* Highlight Metrics Box */}
                            <div className="mt-2.5 p-3 rounded-xl bg-gradient-to-r from-amber-50/90 to-amber-100/60 dark:from-amber-950/30 dark:to-slate-800/80 border border-amber-200/70 dark:border-amber-900/40 flex items-center justify-between">
                              <div>
                                <span className="text-[10px] font-bold uppercase tracking-wider text-amber-800 dark:text-amber-400 block">
                                  Total Barang
                                </span>
                                <span className="text-base font-extrabold text-slate-900 dark:text-slate-100">
                                  {totalPcs} <span className="text-xs font-semibold text-slate-500">PCS</span>
                                </span>
                              </div>
                              <div className="text-right">
                                <span className="text-[10px] font-bold uppercase tracking-wider text-amber-800 dark:text-amber-400 block">
                                  Total Berat
                                </span>
                                <span className="text-base font-extrabold text-amber-600 dark:text-amber-400 font-mono">
                                  {totalBerat} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Footer Actions (Thumb Friendly) */}
                        <div className="pt-3 border-t border-slate-100 dark:border-slate-800 space-y-2 mt-3">
                          {isPending && canVerify && (
                            <div className="grid grid-cols-2 gap-2">
                              <button
                                type="button"
                                onClick={() => openConfirm(trx, 'disetujui')}
                                className="w-full py-2.5 px-3 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-xs font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                              >
                                <IconCheck size={16} />
                                <span>Setujui</span>
                              </button>
                              <button
                                type="button"
                                onClick={() => openConfirm(trx, 'ditolak')}
                                className="w-full py-2.5 px-3 bg-rose-600 hover:bg-rose-700 active:bg-rose-800 text-white text-xs font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                              >
                                <IconX size={16} />
                                <span>Tolak</span>
                              </button>
                            </div>
                          )}

                          {!canVerify && canCancelTransfer(trx) && (
                            <button
                              type="button"
                              onClick={() => openConfirm(trx, 'batal')}
                              className="w-full py-2 px-3 bg-rose-50 hover:bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 text-xs font-bold rounded-xl border border-rose-200 dark:border-rose-800 transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                            >
                              <IconBan size={15} />
                              <span>Batalkan Permohonan</span>
                            </button>
                          )}

                          <div className="flex items-center gap-2">
                            <button
                              type="button"
                              onClick={() => handleOpenDetail(trx.id, trx, 'ringkasan')}
                              className="flex-1 py-2 px-3 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 text-xs font-semibold rounded-xl transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                            >
                              <IconListDetails size={15} />
                              <span>Detail Item</span>
                            </button>
                            <button
                              type="button"
                              onClick={() => handleOpenDetail(trx.id, trx, 'galeri')}
                              className="py-2 px-3 bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/30 dark:hover:bg-amber-900/40 text-amber-700 dark:text-amber-400 text-xs font-semibold rounded-xl border border-amber-200 dark:border-amber-800 transition-all flex items-center justify-center gap-1 cursor-pointer"
                              title="Lihat Galeri Foto"
                            >
                              <IconPhoto size={15} />
                              <span className="hidden sm:inline">Foto</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              /* TABLE VIEW FOR TRANSFER TOKO */
              <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm overflow-x-auto">
                <table className="w-full text-xs text-left text-slate-700 dark:text-slate-300">
                  <thead className="bg-amber-50 dark:bg-slate-800 text-amber-800 dark:text-amber-300 border-b border-amber-200/70 dark:border-slate-700 text-[11px] font-bold uppercase tracking-wider">
                    <tr>
                      <th className="p-3.5">No.</th>
                      <th className="p-3.5">Tanggal</th>
                      <th className="p-3.5">No Transfer</th>
                      <th className="p-3.5">Toko Asal ➔ Tujuan</th>
                      <th className="p-3.5 text-center">Total Barang</th>
                      <th className="p-3.5">Pemohon</th>
                      <th className="p-3.5">Verifikator</th>
                      <th className="p-3.5">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                    {paginatedData.map((trx, idx) => {
                      const totalPcs = trx.total_item || (trx.items ? trx.items.length : 0);
                      const totalBerat = parseFloat(
                        trx.total_berat ||
                          (trx.items ? trx.items.reduce((acc, it) => acc + parseFloat(it.berat || 0), 0) : 0)
                      ).toFixed(3);

                      return (
                        <tr
                          key={trx.id}
                          onClick={() => handleOpenDetail(trx.id, trx, 'ringkasan')}
                          className="hover:bg-amber-50/30 dark:hover:bg-slate-800/40 transition-colors cursor-pointer"
                        >
                          <td className="p-3.5 text-slate-500 font-medium">
                            {(currentPage - 1) * itemsPerPage + idx + 1}.
                          </td>
                          <td className="p-3.5 text-slate-500">
                            {moment(trx.created_at).format('DD MMM YYYY, HH.mm')}
                          </td>
                          <td className="p-3.5 font-mono font-bold text-amber-600 dark:text-amber-400">
                            {trx.no_transfer}
                          </td>
                          <td className="p-3.5 font-medium">
                            {trx.cabang_asal?.nama_cabang || '-'} ➔{' '}
                            <span className="text-amber-600 dark:text-amber-400 font-bold">
                              {trx.cabang_tujuan?.nama_cabang || '-'}
                            </span>
                          </td>
                          <td className="p-3.5 text-center font-bold text-slate-800 dark:text-slate-100">
                            {totalPcs} PCS ({totalBerat} gr)
                          </td>
                          <td className="p-3.5">
                            {trx.user_pemohon?.name || trx.userPemohon?.name || 'Operator'}
                          </td>
                          <td className="p-3.5 font-semibold text-emerald-600">
                            {trx.user_verifikator?.name || '-'}
                          </td>
                          <td className="p-3.5">{renderStatusBadge(trx.status, true)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination Controls for Permohonan */}
            {totalPages > 1 && (
              <div className="flex flex-col sm:flex-row justify-between items-center gap-3 p-4 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm mt-4">
                <span className="text-xs text-slate-500 dark:text-slate-400">
                  Halaman <strong>{currentPage}</strong> dari <strong>{totalPages}</strong> (Total{' '}
                  {filteredData.length} permohonan)
                </span>
                <div className="flex items-center gap-1.5">
                  <button
                    type="button"
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    className="px-3 py-1.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-40 rounded-xl text-xs font-semibold cursor-pointer transition-all"
                  >
                    Sebelumnya
                  </button>
                  <button
                    type="button"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                    className="px-3 py-1.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 disabled:opacity-40 rounded-xl text-xs font-semibold cursor-pointer transition-all"
                  >
                    Selanjutnya
                  </button>
                </div>
              </div>
            )}
          </div>
      </div>

      {/* ═══ SLIDE-OVER DRAWER MODAL DETAIL TRANSFER (5 TAB) ═══ */}
      <Transition appear show={isOpenDetailModal} as={Fragment}>
        <Dialog as="div" className="relative z-[99999]" onClose={() => setIsOpenDetailModal(false)}>
          {/* Backdrop Overlay Tipis & Tanpa Blur */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/15 dark:bg-black/30 pointer-events-auto" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300 sm:duration-400"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300 sm:duration-400"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl xl:max-w-5xl transform bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 text-left align-middle transition-all flex flex-col h-screen max-h-screen">
                  {loadingDetail || !selectedTransfer ? (
                    <div className="p-16 flex flex-col items-center justify-center flex-1">
                      <IconLoader2 size={36} className="animate-spin text-amber-500" />
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-2.5 font-medium">
                        Memuat detail permohonan transfer...
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Drawer Header (Sticky Top) */}
                      <div className="px-5 py-4 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between shrink-0 sticky top-0 z-20">
                        <div>
                          <div className="flex items-center gap-2 flex-wrap">
                            <Dialog.Title as="h3" className="font-bold text-sm md:text-base text-slate-800 dark:text-slate-100">
                              Detail Permohonan:{' '}
                              <span className="font-mono text-amber-600 dark:text-amber-400">
                                {selectedTransfer.no_transfer}
                              </span>
                            </Dialog.Title>
                            {renderStatusBadge(selectedTransfer.status, true)}
                          </div>
                          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-slate-500 dark:text-slate-400 mt-1">
                            <span>
                              Diajukan oleh{' '}
                              <strong className="text-slate-700 dark:text-slate-200">
                                {selectedTransfer.user_pemohon?.name || selectedTransfer.userPemohon?.name || 'Operator'}
                              </strong>{' '}
                              pada {moment(selectedTransfer.created_at).locale('id').format('DD MMMM YYYY HH:mm')}
                            </span>
                            {selectedTransfer.status !== 'menunggu_verifikasi' && selectedTransfer.updated_at && (
                              <span>
                                • <strong className="text-slate-600 dark:text-slate-300">Verifikasi:</strong>{' '}
                                {moment(selectedTransfer.updated_at).locale('id').format('DD MMMM YYYY HH:mm')}
                                {selectedTransfer.user_verifikator?.name && (
                                  <>
                                    {' '}
                                    oleh{' '}
                                    <strong className="text-emerald-600 dark:text-emerald-400">
                                      {selectedTransfer.user_verifikator.name}
                                    </strong>
                                  </>
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => setIsOpenDetailModal(false)}
                          className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors cursor-pointer"
                        >
                          <IconX size={20} />
                        </button>
                      </div>

                      {/* Top Quick Info Strip */}
                      <div className="px-5 py-3 border-b border-slate-100 dark:border-slate-800 bg-slate-50/70 dark:bg-slate-850 shrink-0">
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 text-xs">
                          <div>
                            <span className="text-slate-400 block text-[10px]">Toko Asal</span>
                            <span className="font-bold text-slate-800 dark:text-slate-200 truncate block mt-0.5">
                              {selectedTransfer.cabang_asal?.nama_cabang || '-'}
                            </span>
                          </div>
                          <div>
                            <span className="text-slate-400 block text-[10px]">Toko Tujuan</span>
                            <span className="font-bold text-amber-600 dark:text-amber-400 truncate block mt-0.5">
                              {selectedTransfer.cabang_tujuan?.nama_cabang || '-'}
                            </span>
                          </div>
                          <div>
                            <span className="text-slate-400 block text-[10px]">Operator Pemohon</span>
                            <span className="font-bold text-slate-800 dark:text-slate-200 truncate block mt-0.5">
                              {selectedTransfer.user_pemohon?.name || selectedTransfer.userPemohon?.name || '-'}
                            </span>
                          </div>
                          <div>
                            <span className="text-slate-400 block text-[10px]">Total Item & Berat</span>
                            <span className="font-bold text-slate-800 dark:text-slate-200 truncate block mt-0.5">
                              {selectedTransfer.total_item || (selectedTransfer.items ? selectedTransfer.items.length : 0)} PCS
                              <span className="text-amber-600 dark:text-amber-400 font-semibold ml-1">
                                ({parseFloat(selectedTransfer.total_berat || 0).toFixed(3)} gr)
                              </span>
                            </span>
                          </div>
                          <div>
                            <span className="text-slate-400 block text-[10px]">Verifikator</span>
                            <span className="font-bold text-emerald-600 dark:text-emerald-400 truncate block mt-0.5">
                              {selectedTransfer.user_verifikator?.name ||
                                (selectedTransfer.status === 'menunggu_verifikasi'
                                  ? 'Menunggu...'
                                  : selectedTransfer.status === 'dibatalkan'
                                  ? 'Dibatalkan'
                                  : '-')}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* 5 Tab Navigation Bar */}
                      <div className="flex border-b border-slate-200 dark:border-slate-800 px-5 gap-1 overflow-x-auto scrollbar-none shrink-0 bg-white dark:bg-slate-900">
                        <button
                          type="button"
                          onClick={() => setModalTab('ringkasan')}
                          className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                            modalTab === 'ringkasan'
                              ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                              : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                          }`}
                        >
                          <IconChartPie size={16} />
                          <span>Ringkasan Item</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => setModalTab('list')}
                          className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                            modalTab === 'list'
                              ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                              : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                          }`}
                        >
                          <IconListDetails size={16} />
                          <span>List Item ({selectedTransfer.items?.length || 0})</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => setModalTab('operator')}
                          className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                            modalTab === 'operator'
                              ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                              : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                          }`}
                        >
                          <IconUser size={16} />
                          <span>Operator Pemohon</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => setModalTab('verifikator')}
                          className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                            modalTab === 'verifikator'
                              ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                              : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                          }`}
                        >
                          <IconCircleCheck size={16} />
                          <span>Verifikator</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => setModalTab('galeri')}
                          className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                            modalTab === 'galeri'
                              ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                              : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                          }`}
                        >
                          <IconPhoto size={16} />
                          <span>Galeri List Item</span>
                        </button>
                      </div>

                      {/* Scrollable Tab Body */}
                      <div className="flex-1 overflow-y-auto p-5">
                        {/* 1. Tab Ringkasan Item */}
                        {modalTab === 'ringkasan' && (() => {
                          const itemsList = selectedTransfer.items || [];
                          const totalPcsVal = selectedTransfer.total_item || itemsList.length;
                          const totalBeratVal = parseFloat(selectedTransfer.total_berat || 0);
                          const avgBeratVal = itemsList.length > 0 ? totalBeratVal / itemsList.length : 0;
                          const validModalItems = itemsList.filter(
                            (it) => Number(it.harga_modal || it.item?.harga_modal || 0) > 0
                          );
                          const avgModalVal =
                            validModalItems.length > 0
                              ? Math.round(
                                  validModalItems.reduce(
                                    (acc, it) => acc + Number(it.harga_modal || it.item?.harga_modal || 0),
                                    0
                                  ) / validModalItems.length
                                )
                              : 0;
                          const maxBeratVal =
                            itemsList.length > 0
                              ? Math.max(...itemsList.map((it) => parseFloat(it.berat || it.item?.berat || 0) || 0))
                              : 0;

                          return (
                            <div className="space-y-4">
                              {/* Ringkasan Metrics */}
                              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 sm:gap-3">
                                <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                                  <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">
                                    Total Barang
                                  </span>
                                  <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                                    {totalPcsVal} <span className="text-xs font-semibold text-slate-500">Pcs</span>
                                  </div>
                                </div>
                                <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                                  <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">
                                    Total Berat
                                  </span>
                                  <div className="text-lg font-extrabold text-amber-600 dark:text-amber-400 mt-0.5 font-mono">
                                    {totalBeratVal.toFixed(3)}{' '}
                                    <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                                  </div>
                                </div>
                                <div className="bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 rounded-xl p-3">
                                  <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">
                                    Total Kategori
                                  </span>
                                  <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                                    {Object.keys(detailSummary).length}{' '}
                                    <span className="text-xs font-semibold text-slate-500">Kategori</span>
                                  </div>
                                </div>
                                <div className="bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 rounded-xl p-3">
                                  <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">
                                    Rata-rata Berat
                                  </span>
                                  <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                                    {avgBeratVal.toFixed(3)}{' '}
                                    <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                                  </div>
                                </div>
                                {canVerify && avgModalVal > 0 && (
                                  <div className="bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 rounded-xl p-3">
                                    <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">
                                      Rata-rata Modal
                                    </span>
                                    <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                                      Rp {avgModalVal.toLocaleString('id-ID')}
                                    </div>
                                  </div>
                                )}
                                <div className="bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 rounded-xl p-3">
                                  <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">
                                    Berat Maksimal
                                  </span>
                                  <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                                    {maxBeratVal.toFixed(3)}{' '}
                                    <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                                  </div>
                                </div>
                              </div>

                              {/* Breakdown Kategori & Karat */}
                              {Object.keys(detailSummary).length > 0 && (
                                <div className="space-y-3 p-3.5 bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-900/30 rounded-xl">
                                  <div className="flex items-center justify-between">
                                    <h4 className="text-[11px] font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider flex items-center gap-1.5">
                                      <IconChartPie size={16} />
                                      <span>Breakdown Per Kategori & Karat</span>
                                    </h4>
                                    <span className="text-[10px] text-amber-700 dark:text-amber-400 font-semibold">
                                      {Object.keys(detailSummary).length} Kategori
                                    </span>
                                  </div>
                                  <div className="space-y-2">
                                    {Object.values(detailSummary).map((cat, idx) => (
                                      <div
                                        key={idx}
                                        className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-amber-200/60 dark:border-slate-700 shadow-sm"
                                      >
                                        <div className="flex justify-between items-center mb-2 pb-2 border-b border-slate-100 dark:border-slate-700">
                                          <span className="font-bold text-slate-800 dark:text-slate-100 text-sm">
                                            {cat.name}
                                          </span>
                                          <span className="font-bold text-amber-600 dark:text-amber-400 text-xs bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 px-2.5 py-0.5 rounded-md">
                                            {cat.pcs} PCS ({cat.berat.toFixed(3)} gr)
                                          </span>
                                        </div>
                                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 pt-1">
                                          {Object.entries(cat.byKarat).map(([karat, info]) => (
                                            <div
                                              key={karat}
                                              className="p-2 rounded-lg bg-slate-50 dark:bg-slate-750 border border-slate-100 dark:border-slate-700 text-xs"
                                            >
                                              <span className="text-[10px] text-slate-400 block">Karat: {karat}</span>
                                              <span className="font-bold text-slate-700 dark:text-slate-200">
                                                {info.pcs} pcs{' '}
                                                <span className="text-amber-600 font-mono">({info.berat.toFixed(3)} gr)</span>
                                              </span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })()}

                        {/* 2. Tab List Item */}
                        {modalTab === 'list' && (
                          <div className="space-y-3">
                            <div className="relative">
                              <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                              <input
                                type="text"
                                placeholder="Cari kode barang, jenis, baki..."
                                value={searchModalItem}
                                onChange={(e) => setSearchModalItem(e.target.value)}
                                className="w-full pl-9 pr-3 py-2 text-xs bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500"
                              />
                            </div>

                            <PhotoProvider>
                              <div className="divide-y divide-slate-100 dark:divide-slate-800 border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden bg-white dark:bg-slate-900">
                                {filteredModalItems.map((it, idx) => {
                                  const imgUrl = resolveItemImageUrl(it);

                                  return (
                                    <div
                                      key={it.id || idx}
                                      onClick={() => showDetailItemSingle(it)}
                                      className="p-3 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition flex items-center justify-between gap-3 cursor-pointer"
                                    >
                                      <div className="flex items-center gap-3 min-w-0">
                                        <div
                                          className="w-12 h-12 rounded-xl bg-slate-100 dark:bg-slate-800 overflow-hidden shrink-0 border border-slate-200 dark:border-slate-700 flex items-center justify-center"
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          {imgUrl ? (
                                            <PhotoView src={imgUrl}>
                                              <img src={imgUrl} alt={it.kode_item} className="w-full h-full object-cover cursor-pointer" />
                                            </PhotoView>
                                          ) : (
                                            <IconBox size={22} className="text-slate-300 dark:text-slate-600" />
                                          )}
                                        </div>
                                        <div className="min-w-0">
                                          <div className="flex items-center gap-2">
                                            <span className="font-mono font-bold text-xs text-slate-900 dark:text-slate-100">
                                              {it.kode_item}
                                            </span>
                                            {it.nomor_rak && (
                                              <span className="px-1.5 py-0.2 rounded text-[10px] font-bold bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800">
                                                Baki {it.nomor_rak}
                                              </span>
                                            )}
                                          </div>
                                          <p className="text-xs text-slate-600 dark:text-slate-300 truncate mt-0.5">
                                            {it.jenis_kategori?.nama_jenis || it.kategori || 'Barang Transfer'}
                                          </p>
                                          <p className="text-[11px] text-slate-400">Karat: {it.karat || '-'}</p>
                                        </div>
                                      </div>

                                      <div className="text-right shrink-0">
                                        <span className="font-mono font-bold text-xs text-slate-900 dark:text-slate-100 block">
                                          {parseFloat(it.berat || 0).toFixed(3)} gr
                                        </span>
                                        {canVerify && it.harga_modal && (
                                          <span className="text-[10px] text-slate-400 block font-mono">
                                            Rp {Number(it.harga_modal).toLocaleString('id-ID')}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </PhotoProvider>
                          </div>
                        )}

                        {/* 3. Tab Operator Pemohon */}
                        {modalTab === 'operator' && (
                          <div className="space-y-4">
                            <div className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 space-y-3">
                              <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400 flex items-center justify-center font-bold text-lg">
                                  <IconUser size={24} />
                                </div>
                                <div>
                                  <h4 className="font-bold text-slate-800 dark:text-slate-100 text-sm">
                                    {selectedTransfer.user_pemohon?.name || selectedTransfer.userPemohon?.name || 'Operator Toko'}
                                  </h4>
                                  <p className="text-xs text-slate-500 dark:text-slate-400">
                                    Cabang Asal: {selectedTransfer.cabang_asal?.nama_cabang || '-'}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-2 border-t border-slate-200 dark:border-slate-700/60 space-y-2 text-xs">
                                <div className="flex justify-between">
                                  <span className="text-slate-400">Tanggal Pengajuan:</span>
                                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                                    {moment(selectedTransfer.created_at).locale('id').format('DD MMMM YYYY, HH:mm')}
                                  </span>
                                </div>
                                {selectedTransfer.catatan_pemohon && (
                                  <div className="pt-2">
                                    <span className="text-slate-400 block text-[11px] mb-1">Catatan Pemohon:</span>
                                    <div className="p-3 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 italic">
                                      "{selectedTransfer.catatan_pemohon}"
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* 4. Tab Verifikator */}
                        {modalTab === 'verifikator' && (
                          <div className="space-y-4">
                            <div className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-800 space-y-3">
                              <div className="flex items-center gap-3">
                                <div className="w-12 h-12 rounded-xl bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 flex items-center justify-center font-bold text-lg">
                                  <IconCircleCheck size={24} />
                                </div>
                                <div>
                                  <h4 className="font-bold text-slate-800 dark:text-slate-100 text-sm">
                                    {selectedTransfer.user_verifikator?.name ||
                                      (selectedTransfer.status === 'menunggu_verifikasi'
                                        ? 'Menunggu Proses Verifikasi'
                                        : selectedTransfer.status === 'dibatalkan'
                                        ? 'Dibatalkan Oleh Pemohon'
                                        : 'Sistem')}
                                  </h4>
                                  <p className="text-xs text-slate-500 dark:text-slate-400">
                                    Status:{' '}
                                    <strong className="text-slate-700 dark:text-slate-200 capitalize">
                                      {selectedTransfer.status.replace('_', ' ')}
                                    </strong>
                                  </p>
                                </div>
                              </div>

                              {selectedTransfer.updated_at && selectedTransfer.status !== 'menunggu_verifikasi' && (
                                <div className="pt-2 border-t border-slate-200 dark:border-slate-700/60 space-y-2 text-xs">
                                  <div className="flex justify-between">
                                    <span className="text-slate-400">Waktu Verifikasi:</span>
                                    <span className="font-semibold text-slate-700 dark:text-slate-200">
                                      {moment(selectedTransfer.updated_at).locale('id').format('DD MMMM YYYY, HH:mm')}
                                    </span>
                                  </div>
                                  {selectedTransfer.catatan_verifikasi && (
                                    <div className="pt-2">
                                      <span className="text-slate-400 block text-[11px] mb-1">Catatan Verifikasi:</span>
                                      <div className="p-3 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 italic">
                                        "{selectedTransfer.catatan_verifikasi}"
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* 5. Tab Galeri List Item */}
                        {modalTab === 'galeri' && (
                          <div>
                            <PhotoProvider>
                              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                                {(selectedTransfer.items || []).map((it, idx) => {
                                  const imgUrl = resolveItemImageUrl(it);

                                  return (
                                    <div
                                      key={it.id || idx}
                                      className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-2 flex flex-col justify-between"
                                    >
                                      <div className="aspect-square rounded-lg bg-slate-100 dark:bg-slate-800 overflow-hidden relative group">
                                        {imgUrl ? (
                                          <PhotoView src={imgUrl}>
                                            <img
                                              src={imgUrl}
                                              alt={it.kode_item}
                                              className="w-full h-full object-cover cursor-pointer group-hover:scale-105 transition"
                                            />
                                          </PhotoView>
                                        ) : (
                                          <div className="w-full h-full flex flex-col items-center justify-center text-slate-300 dark:text-slate-600">
                                            <IconPhoto size={24} />
                                          </div>
                                        )}
                                      </div>
                                      <div className="pt-2 text-xs">
                                        <p className="font-mono font-bold text-slate-900 dark:text-slate-100 truncate">
                                          {it.kode_item}
                                        </p>
                                        <p className="text-[11px] text-slate-500 truncate">
                                          {it.jenis_kategori?.nama_jenis || it.kategori || '-'}
                                        </p>
                                        <p className="font-mono font-semibold text-amber-600 text-[11px] mt-0.5">
                                          {parseFloat(it.berat || 0).toFixed(3)} gr
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </PhotoProvider>
                          </div>
                        )}
                      </div>

                      {/* Drawer Footer (Sticky Bottom Action Bar) */}
                      <div className="p-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 flex items-center justify-between gap-2 shrink-0">
                        <button
                          type="button"
                          onClick={() => setIsOpenDetailModal(false)}
                          className="px-4 py-2 text-xs font-semibold rounded-xl border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300 cursor-pointer"
                        >
                          Tutup
                        </button>

                        <div className="flex items-center gap-2">
                          {selectedTransfer.status === 'menunggu_verifikasi' && canVerify && (
                            <>
                              <button
                                type="button"
                                onClick={() => openConfirm(selectedTransfer, 'ditolak')}
                                className="px-3.5 py-2 rounded-xl bg-rose-600 hover:bg-rose-700 text-white text-xs font-bold shadow-sm transition cursor-pointer"
                              >
                                Tolak
                              </button>
                              <button
                                type="button"
                                onClick={() => openConfirm(selectedTransfer, 'disetujui')}
                                className="px-4 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold shadow-sm transition cursor-pointer"
                              >
                                Setujui Transfer
                              </button>
                            </>
                          )}

                          {!canVerify && canCancelTransfer(selectedTransfer) && (
                            <button
                              type="button"
                              onClick={() => openConfirm(selectedTransfer, 'batal')}
                              className="px-3.5 py-2 rounded-xl bg-rose-50 hover:bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 text-xs font-bold border border-rose-200 dark:border-rose-800 transition cursor-pointer"
                            >
                              Batalkan Permohonan
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* ═══ CONFIRMATION MODAL (Approve / Reject / Batal) ═══ */}
      {confirmModal.isOpen && (
        <div className="fixed inset-0 z-[100002] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div
            className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-slate-800 p-5 shadow-2xl border border-slate-200 dark:border-slate-700 text-left align-middle transition-all space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-3">
              <div
                className={`p-2.5 rounded-xl ${
                  confirmModal.action === 'disetujui'
                    ? 'bg-emerald-100 text-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-400'
                    : 'bg-red-100 text-red-600 dark:bg-red-950/40 dark:text-red-400'
                }`}
              >
                {confirmModal.action === 'disetujui' ? (
                  <IconCheck size={22} />
                ) : confirmModal.action === 'batal' ? (
                  <IconBan size={22} />
                ) : (
                  <IconX size={22} />
                )}
              </div>
              <div>
                <h3 className="text-base font-bold text-slate-800 dark:text-slate-100">
                  {confirmModal.action === 'disetujui'
                    ? 'Setujui Transfer Barang'
                    : confirmModal.action === 'batal'
                    ? 'Batalkan Pengajuan Transfer'
                    : 'Tolak Pengajuan Transfer'}
                </h3>
                <p className="text-xs text-slate-500 mt-0.5">
                  No Transfer: <strong>{confirmModal.transfer?.no_transfer}</strong>
                </p>
              </div>
            </div>

            <div className="space-y-3">
              <p className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
                {confirmModal.action === 'disetujui'
                  ? `Apakah Anda yakin ingin menyetujui perpindahan ${
                      confirmModal.transfer?.total_item || confirmModal.transfer?.items?.length
                    } barang ke toko ${confirmModal.transfer?.cabang_tujuan?.nama_cabang}? Barang akan otomatis berpindah cabang.`
                  : confirmModal.action === 'batal'
                  ? 'Apakah Anda yakin ingin membatalkan pengajuan transfer ini? Barang akan dibuka kuncinya kembali.'
                  : 'Apakah Anda yakin ingin menolak pengajuan ini? Silakan isi alasan penolakan.'}
              </p>

              {confirmModal.action !== 'batal' && (
                <div className="space-y-1.5">
                  <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300">
                    Catatan Verifikasi {confirmModal.action === 'ditolak' && <span className="text-red-500">*</span>}
                  </label>
                  <textarea
                    rows={3}
                    autoFocus
                    value={catatanVerifikasi}
                    onChange={(e) => setCatatanVerifikasi(e.target.value)}
                    placeholder={
                      confirmModal.action === 'ditolak'
                        ? 'Contoh: Stok di toko asal masih dibutuhkan / barang tidak sesuai'
                        : 'Catatan tambahan (opsional)'
                    }
                    className="w-full px-3 py-2 rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 text-xs focus:ring-2 focus:ring-amber-500 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500 resize-none cursor-text select-text relative z-10 pointer-events-auto"
                  />
                </div>
              )}
            </div>

            <div className="flex items-center justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
              <button
                type="button"
                disabled={submittingAction}
                onClick={closeConfirm}
                className="px-3.5 py-2 rounded-xl border border-slate-300 dark:border-slate-600 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition cursor-pointer"
              >
                Batal
              </button>
              <button
                type="button"
                disabled={submittingAction}
                onClick={handleConfirmSubmit}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-xl text-white text-xs font-semibold shadow-md transition cursor-pointer ${
                  confirmModal.action === 'disetujui'
                    ? 'bg-emerald-500 hover:bg-emerald-600'
                    : 'bg-red-500 hover:bg-red-600'
                }`}
              >
                {submittingAction && <IconLoader2 size={15} className="animate-spin" />}
                <span>
                  {confirmModal.action === 'disetujui'
                    ? 'Ya, Setujui'
                    : confirmModal.action === 'batal'
                    ? 'Ya, Batalkan'
                    : 'Ya, Tolak'}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </Layouts>
  );
}
